import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "answer-wrapper" }

import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionAndAnswer',
  props: {
    showAnswer: { type: Boolean, default: false },
    showCaret: { type: Boolean, default: true },
    showBorder: { type: Boolean, default: true }
},
  setup(__props) {

const props = __props;

const isAnswerVisible = ref(props.showAnswer);

const toggleAnswer = () => {
  isAnswerVisible.value = !isAnswerVisible.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["question", {'border border-1 rounded-3': __props.showBorder}])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["question-header d-flex justify-content-between align-items-center fst-italic text-success", {'border-2 p-2': __props.showBorder}]),
      onClick: toggleAnswer
    }, [
      _renderSlot(_ctx.$slots, "question", {}, () => [
        _cache[0] || (_cache[0] = _createTextVNode("Question text missing!"))
      ]),
      (__props.showCaret)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(['caret', {'bi-caret-up-fill': isAnswerVisible.value, 'bi-caret-down-fill': !isAnswerVisible.value}])
          }, null, 2))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["question-answer", {'px-2': __props.showBorder}])
          }, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _cache[1] || (_cache[1] = _createTextVNode("Answer text missing!"))
            ])
          ], 2)
        ], 512), [
          [_vShow, isAnswerVisible.value]
        ])
      ]),
      _: 3
    })
  ], 2))
}
}

})